import { call, put, takeEvery } from 'redux-saga/effects';

import {
  categoryLayoutChanged,
  categoryLayoutFailed,
} from '../actions/category';
import { putSession } from '../../../globals/api/requests';

export function* changeLayout({ mode }) {
  try {
    yield put(categoryLayoutChanged(mode));
    const response = yield call(putSession, 'categoryLayout', mode);
    if (response.status !== 200) {
      yield put(
        categoryLayoutFailed(`Failed with response code: ${response.status}`)
      );
    }
  } catch (e) {
    yield put(categoryLayoutFailed(e.message));
  }
}

function* mySaga() {
  yield takeEvery('CATEGORY_LAYOUT_REQUEST', changeLayout);
}

if (IS_BROWSER) {
  window.registerSaga(mySaga);
}

export default mySaga;
